import { Component, DestroyRef, ViewChild, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from '../../service/settings.service';
import { CommentsService } from '../../service/comments.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ReportService } from '../../service/report.service';
import { ReportFilterService } from '../../service/report-filter.service';
import { deepCopy, getKeyValue, isGeoPoint, isObject, isTime, isTimeStamp, operatorOptions, typeOptions } from 'na-lib';
import { isDateTime, isDateTimeGetTimeSeconds, isDateGetTimeSeconds} from 'na-lib';
import { ReportFilterSettingsDialogComponent } from '../report-filter-settings-dialog/report-filter-settings-dialog.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReportsListItemMediaDisplay } from '../reports-list-item-media-display';
import { ReportsListItemActionDisplay } from '../reports-list-item-action-display';
import { MatDialog } from '@angular/material/dialog';
// AG GRID
import { AG_GRID_LOCALE_DE } from '@ag-grid-community/locale';
import { AG_GRID_LOCALE_EN } from '@ag-grid-community/locale';
import { AG_GRID_LOCALE_ES } from '@ag-grid-community/locale';
import { AgGridAngular } from 'ag-grid-angular'
import { themeQuartz, iconSetQuartzLight, GridOptions, ExcelStyle } from 'ag-grid-community';
import type { GridReadyEvent, ICellRendererParams, DataTypeDefinition, DateTimeStringDataTypeDefinition, SelectionColumnDef } from "ag-grid-community";
import type { ColDef } from 'ag-grid-community';
import { ReportsListItemBooleanDisplay } from '../boolean-icon-renderer.component';
import { ReportsListItemGeopointDisplay } from '../reports-list-item-geopoint-display';
import { LocalStorageService } from '../../service/local-storage-service.service';
import { TridyQrExportDialogComponent } from '../../tridy/tridy-qr-export-dialog/tridy-qr-export-dialog.component';

//const dateTimeRegex = /(\d{2})\/(\d{2})\/(\d{4}).{1,2}(\d{2}):(\d{2}):(\d{2})/;
const pad = (n: number) => (n < 10 ? `0${n}` : n);
// const rand = (min: number, max: number) =>
//   Math.floor((max + min) * Math.random() - min);

@Component({
    selector: 'app-reports-item-tridys-list-aggrid',
    templateUrl: './reports-item-tridys-list-aggrid.component.html',
    styleUrl: './reports-item-tridys-list-aggrid.component.css',
    standalone: false
})

export class ReportsItemTridysListAggridComponent {
  reportId:any
  routerUrl:any
  idToShow:string
  reportsList:any
  selectedTridys: any[] = [];
  contentTypes: any[] = [];
  readonly rowSelection: any = {
    mode: 'multiRow',
    checkboxes: true,
    headerCheckbox: true,
    selectAll: 'filtered',
    enableClickSelection: false
  };
  readonly selectionColumnDef: SelectionColumnDef = {
    width: 56,
    resizable: false,
    cellStyle: { display: 'flex', alignItems: 'center' }
  };
  reportData:any
  reportDisplayName:any
  tridysList:any
  contentTypeId:any
  displayName:any
  displayedColumnsAG: ColDef[] = [ {field:'timeStamp'}, {field:"creationDate"}];
  @ViewChild(AgGridAngular) agGridReports!: AgGridAngular;
  agGridReportsApi!: any;
  columnApi!: any;
  autoSizeStrategy:any;

  public theme = themeQuartz
    .withPart(iconSetQuartzLight)
    .withParams({
      backgroundColor: "#ffffff",
      columnBorder: false,
      foregroundColor: "rgb(46, 55, 66)",
      headerBackgroundColor: "#fff",
      headerFontSize: 14,
      headerFontWeight: 600,
      //headerTextColor: "#414141",
      //headerTextColor: "var(--warmOrange)",
      //oddRowBackgroundColor: "#F9FAFB",
      //accentColor: "var(--warmOrange)",
      rowBorder: true,
      sidePanelBorder: false,
      //spacing: 8,
      fontFamily: 'Roboto, sans-serif',
      wrapperBorder: false,
      wrapperBorderRadius: 0
    });

  operatorOptions = operatorOptions;
  typeOptions = typeOptions;
  breakpoint: number;
  paginatorSize = this.settingService.paginator$;
  searchText = '';
  reportsDataList:any;
  showFiller = false;
  reportTemplate:any;
  panelOpenState = false;
  lastRouteValue:any;
  resultFields:any = [];
  reportLoadFromNextId= undefined
  filteredReportsData:any=[];
  filtersValues:any;
  private destroyRef = inject(DestroyRef);
  paginationPageSizeSelector: number[] | boolean = [15,25,50,100];//[5, 10, 50,200, 500, 1000];
  defaultPageSize: number = 25;
  currentLang:any;
  paginationAndFiltering = true
  resultsNotPaginated = []
  private saveTimeout: any;
  private gridStateKey: string;
  private gridInitialized = false;
  private originalColumnOrder: string[] = [];
  private originalColumnWidths: { [colId: string]: number } = {};
  private isResettingPreferences = false;
  masterDetail = false;
  dictionaryFieldKeys: string[] = [];
  detailCellRendererParams: any;
  detailRowAutoHeight = true;

  dataTypeDefinitions: {
    [cellDataType: string]: DataTypeDefinition;
    //- valueParser --> used after user edits cell
    //- valueFormatter --> user when displaying the cell value
    //- dateParser --> used when using date filter input
    //- dateFormatter --> used when displaying date in date filter
  } = {

  number: {
    extendsDataType: 'number',
    baseDataType: 'number',
    valueFormatter:( params:ICellRendererParams) => {
      return params?.data[params.column.getColId()]
    }
  } as DataTypeDefinition,

    dateTimeString: {
      baseDataType: "dateTimeString",
      extendsDataType: "dateTimeString",

      valueFormatter: params => {
        const timeseconds = isDateTimeGetTimeSeconds(params.value);
        const date = new Date(timeseconds)

        const dayString = String(date.getDate());
        const monthString = String(date.getMonth() + 1);

        return !timeseconds || isNaN(timeseconds)
            ? ''
            : `${dayString.length===1 ? '0' + dayString : dayString}.${monthString.length===1 ? '0' + monthString : monthString}.${date.getFullYear()}, ${pad(date.getHours())}:${pad(date.getMinutes())}`;
      }
    } as DateTimeStringDataTypeDefinition,

    timeString: {//timeString
      // filter: 'agSetColumnFilter', // or agTextColumnFilter

      baseDataType: 'text',
      extendsDataType:'text',
      valueFormatter: ({ value }) => {
        // console.log(value)
        const timeseconds = isDateTimeGetTimeSeconds(value);
        const date = new Date(timeseconds)

        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return !isNaN(timeseconds) ? `${hours}:${minutes}` : undefined;
      },
      dateParser: (value) => {
        //console.log(value)
      },
      dateFormatter: ( value)=> {
        //console.log(value)
      }

    } as DataTypeDefinition,

  }

  columnTypes = {
    timeString: {

      valueFormatter: params => {
        //console.log(params)
        const date = new Date(params.value);
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
      },
      filter: 'agNumberColumnFilter', // or agTextColumnFilter
      filterParams: {
        // filter only on HH:mm
        keyCreator: params => {
          const date = new Date(params.value);
          return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
        }
      },
      filterValueGetter: params => {
        const date = new Date(params.data[params.colDef.field]);
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
      },
      sortable: true,
      resizable: true,


    }
  };

  localeText = AG_GRID_LOCALE_EN;

  gridOptions: GridOptions = {

    valueCache: true,
    enableFilterHandlers: true,

    // expand filter sections
    onFilterOpened: (event) => {
      setTimeout(() => {
        const multiFilter = document.querySelector('.ag-multi-filter');
        if (!multiFilter) return;

        const groups = multiFilter.querySelectorAll('.ag-multi-filter-group');
        groups.forEach((group, idx) => {
          if (idx === 0) { // expand the first (comparison) filter
            const container = group.querySelector('.ag-multi-filter-group-container');
            const titleBar  = group.querySelector('.ag-multi-filter-group-title-bar');
            if (container?.classList.contains('ag-hidden') && titleBar) {
              (titleBar as HTMLElement).click();
            }
          }
        });
      }, 0);
    },

    getContextMenuItems: (params) => {
      if (params.column && params.column.getColId() === 'action') {
        return [];
      }
      return (params.defaultItems || []).filter(item =>
        item !== 'cut' &&
        item !== 'paste' &&
        item !== 'export' &&
        item !== 'separator' &&
        item !== 'copyWithGroupHeaders'
      );
    },
    defaultExcelExportParams: {
      processCellCallback: (p) => {
        const v = p.value;
        const cellDataType = p.column.getColDef().cellDataType
        const pad = (n: number) => String(n).padStart(2, '0');

        if(cellDataType != 'dateTime' && cellDataType != 'date' && cellDataType != 'timeString'){
          if (typeof v === 'object' && v !== null && cellDataType != 'dateTime' && cellDataType != 'date' && cellDataType != 'time')
            return this.getCellDictionaryFormated(v);

          if(Array.isArray(v))
            return v.map(obj => this.getCellDictionaryFormated(obj)).join('\n')

          if (v == null) return v;

          // EXCEL AUTO NUMBER RECOGNITION FIX
          // If it's already a string, decide if we must force text.
          if (typeof v === 'string') {
            // Heuristics: looks like a phone -> force text
            const looksLikePhone =
              /^\+/.test(v)            // +49...
              || /^0\d+/.test(v)       // leading zero
              || /[()\-\s]/.test(v)    // spaces, dashes, parentheses
              || /^\d{10,}$/.test(v);  // long digit string -> Excel will use scientific

            return looksLikePhone ? `'${v}` : v;  // leading apostrophe => Excel stores as text
          }

          // Numbers that are “too large” (e.g., 11+ digits) should also be exported as text.
          // Note: if your data *should* keep leading zeros, send them as strings before export.
          if (typeof v === 'number') {
            const abs = Math.abs(v);
            if (abs >= 1e10) return `'${String(v)}`;  // prevent 4.91716E+11
          }
        }else{
          if (cellDataType === 'dateTime' && v instanceof Date)
            return `${pad(v.getDate())}.${pad(v.getMonth() + 1)}.${v.getFullYear()} ${pad(v.getHours())}:${pad(v.getMinutes())}`;

          if (cellDataType === 'date' && v instanceof Date)
            return `${pad(v.getDate())}.${pad(v.getMonth() + 1)}.${v.getFullYear()}`;

          if (cellDataType === 'timeString' ){
            if(typeof v == 'string'){
              const isoStringDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
              const isIsoDate = isoStringDateRegex.test(v) && !isNaN(Date.parse(v))

              if(isIsoDate){
                const vdate = new Date(v)
                return `${pad(vdate.getHours())}:${pad(vdate.getMinutes())}`;
              }
            }
            return isTimeStamp(v) ? isTime(v) : '';
          }
        }

        return v ? v : undefined;
      }
      /* STOP ANY EXCEL AUTO-FORMATTING ON STRINGS
        processCellCallback: (p) => {
        const v = p.value;
        return (typeof v === 'string' && v !== '') ? `'${v}` : v;
      } */

    },
    defaultCsvExportParams: {
      processCellCallback: (p) => {
        const v = p.value;
        const cellDataType = p.column.getColDef().cellDataType
        const pad = (n: number) => String(n).padStart(2, '0');
        //console.log(cellDataType, p.column.getColDef().headerName, p.column.getColDef().field)

        if(cellDataType != 'dateTime' && cellDataType != 'date' && cellDataType != 'timeString'){

          if (typeof v === 'object' && v !== null)
            return this.getCellDictionaryFormated(v);

          if(Array.isArray(v))
            return v.map(obj => this.getCellDictionaryFormated(obj)).join('; ')

        }else{
          if (cellDataType === 'dateTime' && v instanceof Date)
            return `${pad(v.getDate())}.${pad(v.getMonth() + 1)}.${v.getFullYear()} ${pad(v.getHours())}:${pad(v.getMinutes())}`;

          if (cellDataType === 'date' && v instanceof Date)
            return `${pad(v.getDate())}.${pad(v.getMonth() + 1)}.${v.getFullYear()}`;

          if (cellDataType === 'timeString' ){
            if(typeof v == 'string'){
              const isoStringDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;

              const isIsoDate = isoStringDateRegex.test(v) && !isNaN(Date.parse(v))
              if(isIsoDate){
                const vdate = new Date(v)
                return `${pad(vdate.getHours())}:${pad(vdate.getMinutes())}`;
              }
            }
            return isTimeStamp(v) ? isTime(v) : '';
          }
        }

        return v ? v : undefined;
      }
    }
  };

  excelStyles: ExcelStyle[] = [
    {
      id: 'header',
      font: { bold: true, size: 16, color: '#ffffff' },
      alignment: { horizontal: 'Left', vertical: 'Automatic', wrapText: true },
      interior: { color: '#ff5e38', pattern: 'Solid' }
    },
    {
      id: 'cell',
      font: { size: 14, color: '#111111' },
      alignment: { horizontal: 'Left', vertical: 'Automatic' },
      borders: {
        borderBottom: { color: '#E5E7EB', lineStyle: 'Continuous', weight: 1 },
        borderTop:    { color: '#E5E7EB', lineStyle: 'Continuous', weight: 1 },
        borderLeft:   { color: '#F3F4F6', lineStyle: 'Continuous', weight: 1 },
        borderRight:  { color: '#F3F4F6', lineStyle: 'Continuous', weight: 1 }
      }
    }
  ];

  constructor(private router: Router,
    private route: ActivatedRoute,
    private settingService: SettingsService,
    private commentService: CommentsService,
    public dialog: MatDialog,
    private reportService:ReportService,
    private reportFilterService: ReportFilterService,
    private translate: TranslateService,
    private localStorageService: LocalStorageService
    ){
    this.routerUrl=this.route.url
    this.idToShow=this.routerUrl.value[this.routerUrl.value.length-1]?.path
    this.reportId = this.routerUrl.value[this.routerUrl.value.length-1]?.path
    this.lastRouteValue=this.routerUrl.value[this.routerUrl.value.length-2]?.path
    this.gridStateKey = `reportGridPreferences_${this.reportId}`;
  }

  isRowMaster = (dataItem: any) => {
    if (!this.dictionaryFieldKeys.length) return false;
    return this.dictionaryFieldKeys.some(key => {
      const val = dataItem?.[key];
      return val != null && typeof val === 'object';
    });
  };

  flattenToRow(obj: any, prefix: string = ''): { [key: string]: any } {
    const row: { [key: string]: any } = {};
    if (!obj || typeof obj !== 'object') return row;

    Object.entries(obj).forEach(([key, val]: [string, any]) => {
      const fullKey = prefix ? `${prefix}.${key}` : key;

      if (val && typeof val === 'object' && !Array.isArray(val)) {
        if (isTimeStamp(val)) {
          row[fullKey] = isDateTime(val);
        } else if (isGeoPoint(val)) {
          const lat = val.lat ?? val.latitude ?? val._latitude ?? 0;
          const lng = val.lng ?? val.longitude ?? val._longitude ?? 0;
          row[fullKey] = `${lat}, ${lng}`;
        } else {
          Object.assign(row, this.flattenToRow(val, fullKey));
        }
      } else if (Array.isArray(val)) {
        row[fullKey] = `[${val.join(', ')}]`;
      } else {
        row[fullKey] = val;
      }
    });
    return row;
  }

  getCellDictionaryFormated(obj:any, parKey: string = ''){
    if(!obj || obj == undefined || obj == null)
    return ''

    if(typeof obj != 'object' && !Array.isArray(obj))
    return obj

    let allCellData = []

    Object.entries(obj).forEach((data) =>{
      const [key, val]:[string,any] = data
      const longKey = parKey ? `${parKey}.${key}` : key

      if(val && typeof val === 'object' && !Array.isArray(val) ){

        if (isTimeStamp(val))
          allCellData.push( val ? `${longKey}: ${isDateTime(val)}` : [val])

        else if(isGeoPoint(val)){
          const value = val as any
          const lat = value.lat ? value.lat : (value.latitude ? value.latitude : (value._latitude ? value._latitude : 0))
          const lng = value.lng ? value.lng : (value.longitude ? value.longitude : (value._longitude ? value._longitude : 0))
          const latlong = lat + ', ' + lng
          allCellData.push( (lat && lng) ? `${longKey}: ${latlong}` : [val])

        }else
          allCellData.push( val && typeof val === 'object' && val !== null && !Array.isArray(val)  ? this.getCellDictionaryFormated(val, longKey) : [val])

      }
      else if(Array.isArray(val))
        allCellData.push( `${longKey}: [${val.map( v => (typeof v === 'object' ? this.getCellDictionaryFormated(v, longKey) : v)).join(',')}]` )
      else
        allCellData.push( val ? `${longKey}: ${val}`  : '')
    })

    return allCellData.join(', ')
  }

  ngOnInit(){
    this.contentTypes = this.settingService.settingsContentTypesWithId || [];
    if (!this.contentTypes.length) {
      this.settingService.observeContextsContentTypesFirestoreWithId(this.settingService.contextId$)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(contentTypes => this.contentTypes = contentTypes || []);
    }

    this.localeText = AG_GRID_LOCALE_EN as any;

      const langKey = this.translate.currentLang() ?? 'en';
      switch(langKey){
        case 'de':
          this.localeText = AG_GRID_LOCALE_DE as any
          break;
        case 'en':
          this.localeText = AG_GRID_LOCALE_EN
          break;
        case 'es':
          this.localeText = AG_GRID_LOCALE_ES as any
          break;
        default:
          this.localeText = AG_GRID_LOCALE_EN
          break;
      }
    

    this.translate.onLangChange.subscribe( lang => {
      const langKey = lang.lang;
      //console.log('langChange:', langKey)
      switch(langKey){
        case 'de':
          this.localeText = AG_GRID_LOCALE_DE as any
          break;
        case 'en':
          this.localeText = AG_GRID_LOCALE_EN
          break;
        case 'es':
          this.localeText = AG_GRID_LOCALE_ES as any
          break;
        default:
          this.localeText = AG_GRID_LOCALE_EN
          break;
      }
      this.refreshFilterTitles()
      this.refreshAllFilters()
    })

    this.router.events.subscribe(value => {//clear queryComponents from filter when leaving reports route
      if(value instanceof NavigationEnd){
        if(!value.url.match(/(.+)reports(.+)/)){
          this.reportFilterService.setQueryParams({})
          this.router.navigate([value.url])
        }
      }
    })
    // this.breakpoint = (window.innerWidth <= 400) ? 1 : 6;
    const last = this.reportService.getReportIdLastOpened()//last==reportId
    this.idToShow = last
    this.reportId = last

    this.reportsList = this.reportService.getReports(last)//this.idToShow
    //console.log(this.reportsList)
    this.reportTemplate = this.reportService.getTemplate(last)//this.idToShow

    this.reportService.lastReportTemplate$.subscribe( value =>{
      //console.log('lastReportTemplate',value)
      this.reportTemplate = value
      this.reportTemplate.filters = value.filters
    })

    this.reportService.lastReportNextId$.subscribe( value =>{

       setTimeout(() => {
        if(value){
          this.disableFiltersAndPagination()
          // this.paginationAndFiltering = false
        }else{
          this.enableFiltersAndPagination()
          this.paginationAndFiltering = true
          // this.restoreGridPreferences();
          // this.gridInitialized = true;
        }
        this.commentService.progressSpin.emit(false)
      }, 500);
      this.reportLoadFromNextId = value
      //console.log('lastReportNextId', value, this.paginationAndFiltering)

    })

    this.reportFilterService.reportDataResultsFilteredValues$
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe( value => {
      //console.log('reportDataResultsFilteredValues',value?.length)
      // this.commentService.progressSpin.emit(true)
      this.resultsNotPaginated = value
      this.reportsList = value
      // this.updateTable()
      // this.commentService.progressSpin.emit(false)
    })

    this.reportService.lastPaginatedReportResults$
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe( value =>{
      // if(this.reportLoadFromNextId)
        this.reportsList = value
      if(value == 0 && this.resultsNotPaginated?.length!=0)
        this.reportsList = this.resultsNotPaginated
    })

    this.reportsDataList = this.settingService.allReports$
    if(this.reportsDataList){
      this.reportsDataList.forEach(element => {
        if(element.id == this.reportId){
          this.reportData = element
          this.reportDisplayName = element.displayName
          this.contentTypeId = element.contentTypeId
          this.displayName = element.displayName
          // this.getTridysContentTypeName()
        }
      });
    }

    //console.log('displayedColumnsAG',this.displayedColumnsAG)
  }

  disableFiltersAndPagination() {
    this.paginationAndFiltering = false;

    const disabledFilters = this.displayedColumnsAG.map((colDef) => {
      if (colDef.filter) {
        return {
          ...colDef,
          filterParams: {
            ...(colDef.filterParams || {}),
            readOnly: true // disable if value is set
          }
        };
      }
      return colDef;
    });
    this.displayedColumnsAG = disabledFilters
    this.refreshAllFilters()

  }

  enableFiltersAndPagination() {
    this.paginationAndFiltering = true;

    const enabledFilters = this.displayedColumnsAG.map((colDef) => {
      if (colDef.filter) {
        return {
          ...colDef,
          filterParams: {
            ...(colDef.filterParams || {}),
            readOnly: false // disable if value is set
          }
        };
      }
      return colDef;
    });
    this.displayedColumnsAG = enabledFilters
    this.originalColumnOrder = this.displayedColumnsAG.map(col => col.field);
    this.refreshAllFilters()
    setTimeout(() => {
      const initialState = this.agGridReportsApi.getColumnState();
      initialState.forEach(col => {
        this.originalColumnWidths[col.colId] = col.width;
      });
      this.restoreGridPreferences();
      this.gridInitialized = true;
    }, 100);
  }

  refreshFilterTitles(): void {
    if (!this.displayedColumnsAG || !this.agGridReportsApi) return;
    this.displayedColumnsAG.forEach(col => {
      if (col.filterParams?.filters) {
        col.filterParams.filters.forEach((f: any) => {
          if (f.filter === 'agSetColumnFilter') {
            f.title = this.translate.instant('filters.panel_search_text');
          } else {
            f.title = this.translate.instant('filters.panel_comparison_filter');
          }
        });
      }
    });
    this.agGridReportsApi.setGridOption('columnDefs', this.displayedColumnsAG);
  }

  refreshAllFilters() {
    const filterModel = this.agGridReports.api.getFilterModel()
    const allColumns = this.agGridReports.api.getColumnDefs()

    allColumns?.forEach(col => {
      const field = col['field']
      this.agGridReports.api.destroyFilter(field!)
    })
    this.agGridReports.api.setFilterModel(filterModel)
  }

  onGridReady(params: GridReadyEvent) {
    this.agGridReportsApi = params.api;
    this.columnApi = (params as any).columnApi;

    const last = this.reportService.getReportIdLastOpened()//last==reportId
    //console.log(last)
    this.agGridReportsApi = params.api;
    if(this.reportTemplate['resultFields']){
      //console.log(this.reportTemplate['resultFields'])
      if(this.reportTemplate.length!=0){
        this.displayedColumnsAG = []
      }

      // used for column flex
      const preferences = this.localStorageService.get(this.gridStateKey);

      this.reportTemplate['resultFields'].forEach((field, index) => {
        const type = this.getColumnType(field.type);
        const filterParamDef = this.getFilterParamFromOperator(field);
        //const filterOptions = this.getFilterOptionsBasedOnType(field);
        const filter = this.reportTemplate?.filters[index]?.description;
        const floatingFilter = true;

        let column: any = {
          field: field.key,
          headerClass: ['my-class1'],
          headerName: field.displayName,
          headerTooltip: filter ?? field.displayName,
          lockPinned: false,
          cellDataType: type,
          filter: true,
          autoHeight: true,
          filterParams: {
            defaultOption: filterParamDef,
            inRangeInclusive:true
          },
          headerStyle: params => {
            //if (floatingFilter) return { color:'var(--warmOrange)' };
            if (params.column.isFilterActive())
              return { backgroundColor: 'rgb(255 94 56 / 20%)', color:'white' };
            return null;
          }
        };

        //flex if no preferences
        if (this.reportTemplate['resultFields'].length < 8 && !preferences) {
          column.flex = 1;
        }

        // Fix for flat keys containing dots
        if (field.key.includes('.')) {
          column.valueGetter = (params) => {
            const parts = field.key.split('.');
            let value = params.data;
            for (let part of parts) {
              if (value && typeof value === 'object' && part in value) value = value[part];
              else return params.data[field.key];
            }
            return value;
          };
        }

        if (field.type === 'geopoint') {
          column.cellRenderer = ReportsListItemGeopointDisplay;
          column.filter = 'agTextColumnFilter';
          column.filterParams = { buttons: ['reset', 'apply'], inRangeInclusive:true };
          column.valueGetter = (params) => {
            const raw = getKeyValue(params.data, field.key);
            if (!raw) return null;

            if (typeof raw === 'string') {
              const m = raw.match(/^\s*(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)\s*$/);
              if (!m) return null;
              const lat = Number(m[1]);
              const lng = Number(m[2]);
              return (Number.isFinite(lat) && Number.isFinite(lng)) ? `${lat}, ${lng}` : null;
            }

            if (isGeoPoint(raw)) {
              const value: any = raw;
              const lat = value.lat ? value.lat : (value.latitude ? value.latitude : (value._latitude ? value._latitude : null));
              const lng = value.lng ? value.lng : (value.longitude ? value.longitude : (value._longitude ? value._longitude : null));
              if (lat == null || lng == null) return null;
              return `${Number(lat)}, ${Number(lng)}`;
            }

            return null;
          };
        }

        if (field.type === 'time') {
          column.type = type;
          column.filter = 'agTextColumnFilter';
          column.filterParams = { buttons: ['reset', 'apply'], inRangeInclusive:true };
          column.filterValueGetter = params => {
            const value = params.data[field.key];
            const timeseconds = isDateGetTimeSeconds(value);
            const date = new Date(timeseconds);
            return !isNaN(timeseconds)
              ? date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })
              : undefined;
          };
          column.filterParams.filterOptions = [
            'equals',
            'notEqual',
            {
              displayKey: 'lessThan',
              displayName: this.localeText['lessThan'],
              predicate: ([filterValue], cellValue) => cellValue == null || cellValue < filterValue
            },
            {
              displayKey: 'greaterThan',
              displayName: this.localeText['greaterThan'],
              predicate: ([filterValue], cellValue) => cellValue == null || cellValue > filterValue
            },
            {
              displayKey: 'greaterThanOrEqual',
              displayName: this.localeText['greaterThanOrEqual'],
              predicate: ([filterValue], cellValue) => cellValue == null || cellValue >= filterValue
            },
            {
              displayKey: 'lessThanOrEqual',
              displayName: this.localeText['lessThanOrEqual'],
              predicate: ([filterValue], cellValue) => cellValue == null || cellValue <= filterValue
            },
            {
              displayKey: 'inRange',
              displayName: this.localeText['inRange'],
              predicate: ([f1, f2], cellValue) => cellValue == null || (cellValue >= f1 && cellValue <= f2),
              numberOfInputs: 2,
            },
            'blank',
            'notBlank'
          ];
        }

        else if (field.type === 'date') {

          column.cellDataType = 'date';
          column.filter = 'agDateColumnFilter';
          column.filterParams = { buttons: ['reset', 'apply'], inRangeInclusive:true };

          column.valueGetter = (params) => {
            const raw = params.data[field.key];
            if (!raw) return null;
            const ms = isDateGetTimeSeconds(raw);
            if (!ms || isNaN(ms)) return null;

            const d = new Date(ms);
            d.setHours(0, 0, 0, 0);
            return d;
          };

          column.valueFormatter = (params) => {
            const d: Date = params.value;
            if (!(d instanceof Date) || isNaN(d.getTime())) return '';
            const dd = String(d.getDate()).padStart(2,'0');
            const mm = String(d.getMonth()+1).padStart(2,'0');
            const yyyy = d.getFullYear();
            return `${dd}.${mm}.${yyyy}`;
          };

          // add a comparator to be safe:
          // column.filterParams.comparator = (filterLocalDateAtMidnight: Date, cellValue?: Date) => {
          //   if (!cellValue) return -1;
          //   const d = new Date(cellValue);
          //   const cellMidnight = new Date(d.getFullYear(), d.getMonth(), d.getDate());
          //   if (cellMidnight < filterLocalDateAtMidnight) return -1;
          //   if (cellMidnight > filterLocalDateAtMidnight) return 1;
          //   return 0;
          // };
        }

        else if (field.type === 'dateTime') {
          column.cellDataType = 'dateTime';
          column.filter = 'agDateColumnFilter';
          column.filterParams = {
            inRangeInclusive:true,
            buttons: ['reset','apply'],
            browserDatePicker: true,
            step: 60, // minute precision

            // compare by minutes (HH:mm), ignore seconds
            comparator: (filterDate: Date, cellValue?: Date) => {
              if (!(cellValue instanceof Date) || isNaN(cellValue.getTime())) return -1;

              // minute-level timestamps
              const cellMin   = Math.floor(cellValue.getTime() / 60000);
              const filterMin = Math.floor(filterDate.getTime()   / 60000);

              return cellMin === filterMin ? 0 : (cellMin < filterMin ? -1 : 1);
            }
          };

          column.valueGetter = (params) => {
            const raw = params.data[field.key];
            if (!raw) return null;
            const ms = isDateGetTimeSeconds(raw);
            return isNaN(ms) ? null : new Date(ms);
          };

          column.valueFormatter = (params) => {
            const d: Date = params.value;
            if (!(d instanceof Date) || isNaN(d.getTime())) return '';
            const pad = (n:number)=>String(n).padStart(2,'0');
            return `${pad(d.getDate())}.${pad(d.getMonth()+1)}.${d.getFullYear()}, ${pad(d.getHours())}:${pad(d.getMinutes())}`;
          };
        }

        else if (field.type === 'number' || field.type === 'decimal') {

          column.cellDataType = 'number';
          column.filter = 'agMultiColumnFilter';
          column.filterParams = {
            filters: [
              {
                display: 'accordion',
                title: this.translate.instant('filters.panel_comparison_filter'),
                filter: 'agNumberColumnFilter',
                filterParams: {
                  defaultOption: 'equals',
                  inRangeInclusive:true,
                  filterOptions: [
                    'equals','notEqual','lessThan','lessThanOrEqual',
                    'greaterThan','greaterThanOrEqual','inRange','blank','notBlank'
                  ],
                },
              },
              {
                display: 'accordion',
                title: this.translate.instant('filters.panel_search_text'),
                filter: 'agSetColumnFilter'
              },
            ],
            //maxNumConditions: 1,
            useForm: true,
            closeOnApply: true,
            buttons: ['reset', 'apply']
          };

          // column.filterParams = { buttons: ['reset', 'apply'] };
          column.valueGetter = p => p.data?.[field.key] != null ? Number(p.data[field.key]) : null;

        }

        else if (field.type === 'boolean') {
          column.cellRenderer = ReportsListItemBooleanDisplay;
          column.filter = 'agSetColumnFilter';
          column.filterParams = {
            values: [true, false],
            buttons: ['reset', 'apply'],
            valueFormatter: (p) =>
              p.value === true
                ? this.localeText['true'] || 'True'
                : this.localeText['false'] || 'False',
          };
        }

        else if (field.type !== 'boolean') {
          column.filter = 'agMultiColumnFilter';
          column.filterParams = {
            filters: [
              {
                display: 'accordion',
                title: this.translate.instant('filters.panel_comparison_filter'),
                filter: 'agTextColumnFilter',
                expanded: true,
              },
              {
                display: 'accordion',
                title: this.translate.instant('filters.panel_search_text'),
                filter: 'agSetColumnFilter',
                expanded: true,
              }
            ],
            buttons: ['reset','apply'], //if removed, it will be auto applied
            // maxNumConditions: 1,
            useForm: true,
            closeOnApply: true,
          };

          //column.filterParams.filterOptions = filterOptions as IIRFilterOptions[];
        }

        else {
          column.filterParams.buttons = ['reset','apply'];
          // Does that also reset the advanced filter? ???
          column.filterParams.filterOptions = [
            {
              displayKey: 'equals',
              displayName: this.localeText['equals'],
              predicate: ([filterValue], cellValue) => cellValue == filterValue
            },
            {
              displayKey: 'notEqual',
              displayName: this.localeText['notEqual'],
              predicate: ([filterValue], cellValue) => cellValue != filterValue
            }
          ]
        }

        if (field.type === 'media') {
          column.cellRenderer = ReportsListItemMediaDisplay;
        }

        if (field.type === 'dictionary') {
          this.dictionaryFieldKeys.push(field.key);
          column.hide = true;
          const displayName = field.displayName || field.key;
          column.valueFormatter = (params) => {
            const raw = params.data?.[field.key];
            if (!raw) return '';
            if (Array.isArray(raw)) return `${displayName} [${raw.length}]`;
            if (typeof raw === 'object') return displayName;
            return raw;
          };
          column.filter = 'agMultiColumnFilter'
          column.filterParams = {
            filters: [
              {
                display: 'accordion',
                title: this.translate.instant('filters.panel_comparison_filter'),
                filter: 'agTextColumnFilter',
                filterParams: {
                  defaultOption: 'contains',
                  filterOptions: [
                    'contains', 'notContains', 'equals', 'notEqual',
                    'startsWith', 'endsWith', 'blank', 'notBlank'
                  ],
                  textMatcher: (params) => {
                    const raw = params.data?.[field.key];
                    if (!raw) {
                      if (params.filterOption === 'blank') return true;
                      if (params.filterOption === 'notBlank') return false;
                      return false;
                    }
                    let text: string;
                    if (Array.isArray(raw)) {
                      text = raw.map(item => this.getCellDictionaryFormated(item)).join(', ');
                    } else {
                      text = this.getCellDictionaryFormated(raw);
                    }
                    text = (text || '').toString().toLowerCase();
                    const filterText = (params.filterText || '').toLowerCase();

                    switch (params.filterOption) {
                      case 'contains': return text.includes(filterText);
                      case 'notContains': return !text.includes(filterText);
                      case 'equals': return text === filterText;
                      case 'notEqual': return text !== filterText;
                      case 'startsWith': return text.startsWith(filterText);
                      case 'endsWith': return text.endsWith(filterText);
                      case 'blank': return !text || text.trim() === '';
                      case 'notBlank': return !!text && text.trim() !== '';
                      default: return text.includes(filterText);
                    }
                  }
                }
              },
              {
                display: 'accordion',
                title: this.translate.instant('filters.panel_search_text'),
                filter: 'agSetColumnFilter'
              }
            ],
            buttons: ['reset', 'apply'],
            useForm: true,
            closeOnApply: true
          }

          column.filterValueGetter = (params) => {
            const value = params.data[field.key];
            if( !value) return;

            const entries = this.getAllEntries(value)
            return entries.filter((item, index) => entries.indexOf(item) === index) //remove duplicates
          }
        }

        this.displayedColumnsAG.push(column);
      });

      // Configure master-detail if there are dictionary fields
      if (this.dictionaryFieldKeys.length > 0) {
        this.masterDetail = true;
        this.detailCellRendererParams = (masterParams: any) => {
          // Collect all rows and unique keys from all dictionary fields
          const rows: any[] = [];
          const allKeys = new Set<string>();

          this.dictionaryFieldKeys.forEach(dictKey => {
            const fieldDef = this.reportTemplate['resultFields']?.find(f => f.key === dictKey);
            const displayName = fieldDef?.displayName || dictKey;
            const val = masterParams.data[dictKey];
            if (val) {
              const items = Array.isArray(val) ? val : [val];
              items.forEach((item, idx) => {
                const flatRow = this.flattenToRow(item);
                Object.keys(flatRow).forEach(k => allKeys.add(k));
                const label = Array.isArray(val)
                  ? `${displayName} [${idx}]`
                  : displayName;
                rows.push({ __detailField__: label, ...flatRow });
              });
            }
          });

          // Build dynamic column definitions from collected keys
          const dynamicCols: ColDef[] = [
            ...Array.from(allKeys).map(key => ({
              field: key,
              headerName: key,
              flex: 1,
              minWidth: 150,
              resizable: true,
              sortable: true,
              valueGetter: (params) => params.data?.[key],
              filter: 'agMultiColumnFilter',
              filterParams: {
                filters: [
                  {
                    display: 'accordion',
                    expanded: true,
                    title: this.translate.instant('filters.panel_comparison_filter'),
                    filter: 'agTextColumnFilter',
                    filterParams: {
                      defaultOption: 'contains',
                      filterOptions: [
                        'contains', 'notContains', 'equals', 'notEqual',
                        'startsWith', 'endsWith', 'blank', 'notBlank'
                      ]
                    }
                  },
                  {
                    display: 'accordion',
                    title: this.translate.instant('filters.panel_search_text'),
                    filter: 'agSetColumnFilter'
                  }
                ],
                buttons: ['reset', 'apply'],
                useForm: true,
                closeOnApply: true
              },
            } as ColDef))
          ];

          return {
            detailGridOptions: {
              enableFilterHandlers: true,
              columnDefs: dynamicCols,
              defaultColDef: { resizable: true, sortable: true },
              domLayout: 'autoHeight',
              popupParent: document.body,
              theme: this.theme,
              localeText: this.localeText,
            },
            getDetailRowData: (params) => {
              params.successCallback(rows);
            }
          };
        };

        // Add expand/collapse column at the start
        this.displayedColumnsAG.unshift({
          headerName: '',
          cellRenderer: 'agGroupCellRenderer',
          width: 50,
          minWidth: 50,
          maxWidth: 50,
          resizable: false,
          sortable: false,
          filter: false,
          suppressMovable: true,
          lockPosition: 'left',
          suppressHeaderMenuButton: true,
        } as ColDef);
      }

      this.displayedColumnsAG.push(
        {
          field:'action',
          minWidth: 90,
          width:90,
          headerName:'',
          pinned: 'right',
          lockPinned: true,
          colId: "action",
          resizable:false,
          suppressNavigable: false,
          sortable: false,
          lockPosition: 'right', // fix column others cant push
          suppressMovable: true, // fix column others cant push
          filter: false,
          suppressHeaderMenuButton: true,
          cellStyle: { display: 'flex' },
          cellRenderer: ReportsListItemActionDisplay,
        }
      );

    }else{

      if(this.reportTemplate[last]){
        this.reportsList = this.reportsList[last]
        if(this.reportTemplate[last]['resultFields']){
          this.reportTemplate[last]['resultFields'].forEach( field => {
            const type = this.getColumnType(field)
            this.displayedColumnsAG.push(
              {
                field:field.key,

                headerName: field.displayName,
                lockPinned: false,
                cellDataType: type
              }
            );
          })
        }
      }
    }

    this.autoSizeStrategy = {
        type: 'fitCellContents',
    };

    this.commentService.progressSpin.emit(false)
  }

  saveGridPreferences(): void {
    if (!this.agGridReportsApi || !this.gridInitialized) return;
    const preferences = {
      columnState: this.agGridReportsApi.getColumnState(),
      filterModel: this.agGridReportsApi.getFilterModel(),
      paginationPageSize: this.agGridReportsApi.paginationGetPageSize(),
      paginationCurrentPage: this.agGridReportsApi.paginationGetCurrentPage()
    };
    this.localStorageService.set(this.gridStateKey, preferences);
  }

  restoreGridPreferences(): void {
    const preferences = this.localStorageService.get(this.gridStateKey);
    if (!preferences || !this.agGridReportsApi) return;

    // Reorder displayedColumnsAG array to match saved column order
    if (preferences.columnState && this.displayedColumnsAG && this.displayedColumnsAG.length > 0) {
      const orderedColumns = [];
      // Add columns in the order they were saved
      preferences.columnState.forEach(savedCol => {
        const found = this.displayedColumnsAG.find(col => col.field === savedCol.colId);
        if (found) {
          orderedColumns.push(found);
        }
      });

      // Add any new columns that weren't in saved state (e.g., report structure changed)
      this.displayedColumnsAG.forEach(col => {
        if (!orderedColumns.find(c => c.field === col.field)) {
          orderedColumns.push(col);
        }
      });

      this.displayedColumnsAG = orderedColumns;
    }

    // Apply column state for widths, sort, visibility, pinned
    if (preferences.columnState) {
      this.agGridReportsApi.applyColumnState({
        state: preferences.columnState,
        applyOrder: true
      });
    }

    if (preferences.filterModel) {
      this.agGridReportsApi.setFilterModel(preferences.filterModel);
    }

    if (preferences.paginationPageSize) {
      this.agGridReportsApi.setGridOption('paginationPageSize', preferences.paginationPageSize);
    }

    if (preferences.paginationCurrentPage != null) {
      this.agGridReportsApi.paginationGoToPage(preferences.paginationCurrentPage);
    }
  }

  onColumnChanged(): void {
    if (this.isResettingPreferences) return;
    clearTimeout(this.saveTimeout);
    this.saveTimeout = setTimeout(() => this.saveGridPreferences(), 300);
  }

  onSortChanged(): void {
    if (this.isResettingPreferences) return;
    this.saveGridPreferences();
  }

  onPaginationChanged(): void {
    if (this.isResettingPreferences) return;
    this.saveGridPreferences();
  }

  resetGridPreferences(): void {
    if (!this.agGridReportsApi || !this.originalColumnOrder.length) return;

    // Block auto-save during reset to prevent re-saving current state
    this.isResettingPreferences = true;

    // Remove saved preferences from localStorage
    this.localStorageService.remove(this.gridStateKey);

    // Reset column order and widths to initial defaults
    const columnState = this.originalColumnOrder.map(colId => ({
      colId,
      width: this.originalColumnWidths[colId] ?? 200,
      sort: null
    }));
    this.agGridReportsApi.applyColumnState({ state: columnState, applyOrder: true });

    // Clear filters
    this.agGridReportsApi.setFilterModel(null);

    // Reset pagination to default
    this.agGridReportsApi.setGridOption('paginationPageSize', this.defaultPageSize);
    this.agGridReportsApi.paginationGoToPage(0);

    // Re-enable auto-save after reset completes
    setTimeout(() => {
      this.isResettingPreferences = false;
    }, 100);
  }

  getAllEntries(obj){
    return Object.values(obj).flatMap(val =>{
      if(typeof val === 'object'){
        if (isTimeStamp(val))
          return val ? isDateTime(val) : [val]
        else if(isGeoPoint(val)){
          const value = val as any
          const lat = value.lat ? value.lat : (value.latitude ? value.latitude : (value._latitude ? value._latitude : 0))
          const lng = value.lng ? value.lng : (value.longitude ? value.longitude : (value._longitude ? value._longitude : 0))
          const latlong = lat + ', ' + lng
          return (lat && lng) ? latlong : [val]
        }else
          return val && typeof val === 'object' && val !== null && !Array.isArray(val)  ? this.getAllEntries(val) : [val]

      }else
        return (val && typeof val != 'object' && val !== null && !Array.isArray(val))  ? val : [val]
    })
  }

  exportExcel() {
    const date = new Date()
    const fileName = `Report_${ isDateTime(date)}.xlsx`
    this.agGridReportsApi.exportDataAsExcel({fileName: fileName, sheetName: this.displayName});
  }

  exportCsv() {
    const date = new Date()
    const fileName = `Report_${ isDateTime(date)}.csv`
    this.agGridReportsApi.exportDataAsCsv({fileName: fileName});
  }

  onSelectionChanged(event: any): void {
    this.selectedTridys = event.api.getSelectedRows() || [];
  }

  openQrExportDialog(): void {
    const selected = this.selectedTridys.filter(tridy => tridy?.id);
    if (!selected.length) return;

    const contentTypeIds = new Set(selected.map(tridy => tridy.contentType || this.contentTypeId || this.reportTemplate?.contentTypeId));
    this.dialog.open(TridyQrExportDialogComponent, {
      width: '760px',
      maxWidth: '96vw',
      data: {
        title: 'Download selected QR codes',
        filenamePrefix: 'dpp-qr-codes',
        contentTypes: this.contentTypes.filter(contentType => contentTypeIds.has(contentType.id)),
        tridys: selected.map(tridy => ({
          id: tridy.id,
          payload: tridy.payload || {},
          nfcURLPrefix: this.contentTypes.find(contentType => contentType.id === (tridy.contentType || this.contentTypeId || this.reportTemplate?.contentTypeId))?.nfcURLPrefix
        }))
      }
    });
  }

  onCellClicked(event: any): void {
    if (!this.masterDetail || !event.column || !event.node) return;
    const colId = event.column.getColId();
    if (this.dictionaryFieldKeys.includes(colId)) {
      const val = event.data?.[colId];
      if (val != null && typeof val === 'object') {
        event.node.setExpanded(!event.node.expanded);
      }
    }
  }

  onFilterChanged() {
    this.filteredReportsData = [];
    this.agGridReportsApi.forEachNodeAfterFilter(row => {
      this.filteredReportsData.push(row.data);
    });
    this.saveGridPreferences();
    //console.log('Filtered Data:', this.filteredReportsData);
  }

  getFilterParamFromOperator(field){
    let filterParam:any = 'equals'

    switch(field.operator){
      case '=':{
        return filterParam = 'equals'
      }
      case '!=':{
        return filterParam = 'notEqual'

      }
      case '>':{
        return filterParam = 'greatherThan'

      }
      case '<':{
        return filterParam = 'lessThan'

      }
      case '>=':{
        return filterParam = 'greaterThanOrEqual'
      }
      case '<=':{
        return filterParam = 'lessThanOrEqual'
      }
      case 'inrange':{
        return filterParam = 'inRange'
      }
      case 'in':{
        return filterParam = {
          filterOptions: ['in'],  // 👈 custom operator
          textCustomComparator: (filter, value, filterText) => {
            try {
              const list = JSON.parse(filterText); // e.g. "[1,3,5]"
              return list.includes(value);
            } catch (e) {
              return false;
            }
          },
        }
      }
      case '!in':{
        return filterParam = {
          filterOptions: ['!in'],  // 👈 custom operator
          textCustomComparator: (filter, value, filterText) => {
            try {
              const list = JSON.parse(filterText); // e.g. "[1,3,5]"
              return !list.includes(value);
            } catch (e) {
              return false;
            }
          },
        }
      }
      case 'contains':{
        return filterParam = 'contains'
      }
      case 'notContains':{
        return filterParam = 'notContains'
      }
      case 'startsWith':{
        return filterParam = 'startsWith'
      }
      case '!startsWith':{
        return filterParam = 'notStartsWith'

      }
      default:{
        return filterParam
      }
    }
  }

  getFilterOptionsBasedOnType(field){ // not used
    let filterOptions = []
    switch(field.type){
      case 'string':{
        filterOptions = ['contains', 'startsWith', 'endsWith', 'equals', 'notEqual', 'blank', 'notBlank']
        break;
      }
      case 'number':{
        //console.log("having numebers:", field)
        filterOptions = ['equals', 'lessThan', 'greaterThan', 'notEqual', 'greaterThanOrEqual', 'lessThanOrEqual','inRange', 'blank', 'notBlank']
        break;
      }
      case 'decimal':{
        filterOptions = ['equals', 'lessThan', 'greaterThan', 'notEqual', 'greaterThanOrEqual', 'lessThanOrEqual','inRange', 'blank', 'notBlank']
        break;
      }
      case 'boolean':{
        filterOptions = ['equals', 'notEqual', 'blank', 'notBlank', 'true', 'false']
        break;
      }
      case 'date':{
        filterOptions = ['equals', 'notEqual','lessThan', 'greaterThan', 'greaterThanOrEqual', 'lessThanOrEqual','inRange','blank','notBlank']
        break;
      }
      case 'time':{
        filterOptions = ['equals', 'notEqual','lessThan', 'greaterThan', 'greaterThanOrEqual', 'lessThanOrEqual','inRange','blank','notBlank']
        break;
      }
      case 'dateTime':{
        filterOptions = ['equals', 'notEqual','lessThan', 'greaterThan', 'greaterThanOrEqual', 'lessThanOrEqual','inRange','blank','notBlank']
        break;
      }
      case 'media':{
        filterOptions = ['equals', 'notEqual','blank','notBlank']
        break;
      }
    }
    return filterOptions
  }

  resetAllFilters(): void {
    if (this.agGridReports?.api) {
      this.agGridReports.api.setFilterModel(null);
      this.agGridReports.api.onFilterChanged();
    }
    this.saveGridPreferences();

    if (this.reportFilterService) {
      this.reportFilterService.setQueryParams({});
    }
  }


  getColumnType(fieldType){
    let type
    switch(fieldType){
      case 'string':{
        type = 'text'
        break;
      }
      case 'geopoint':{
        type = 'text'
        break;
      }
      case 'number':{
        type = 'number'
        break;
      }
      case 'decimal':{
        type = 'number'
        break;
      }
      case 'boolean':{
        type = 'boolean'
        break;
      }
      case 'date':{
        type = 'date'//dateString
        break;
      }
      case 'time':{
        type = 'timeString'
        break;
      }
      case 'dateTime':{
        type = 'dateTime'//dateTimeString
        break;
      }
      case 'media':{
        type = 'text'
        break;
      }
    }
    return type
  }

  backTo(){
    this.clearURLqueryParams()
    this.router.navigate(['home', this.settingService.contextId$,'reports'])
  }

  isDateTime(element){
    let dateValue
    dateValue = element

    if(element){
      if(element['_nanoseconds'] || element['_seconds']){
        const NS_TO_MS_MULTIPLIER = 1/1000000
        const SEC_TO_MS_MULTIPLIER = 1000
        const timestampInMilliseconds = element['_seconds'] * SEC_TO_MS_MULTIPLIER + element['_nanoseconds'] * NS_TO_MS_MULTIPLIER
        const date = new Date(timestampInMilliseconds)
        element= date
        dateValue = date.toUTCString()//----------
      }

      if(element['nanoseconds'] || element['seconds']){
        const NS_TO_MS_MULTIPLIER = 1/1000000
        const SEC_TO_MS_MULTIPLIER = 1000
        const timestampInMilliseconds = element['seconds'] * SEC_TO_MS_MULTIPLIER + element['nanoseconds'] * NS_TO_MS_MULTIPLIER
        const date = new Date(timestampInMilliseconds)
        element= date
        dateValue = date
        // dateValue = date.toUTCString()//----------
      }

      if( typeof element === 'object'){
        const date = new Date(element)
        dateValue = date
        // dateValue = date.toUTCString()//----------
      }

      if( typeof element === 'string'){
        const date = new Date(element)
        dateValue = date
        // dateValue = date.toUTCString()//----------
      }

      try{
        let date = new Date(dateValue)
        dateValue = date
        // dateValue = date.toLocaleDateString('de-DE',{year: 'numeric', month: '2-digit', day:'2-digit'})
      }catch(e){}
    }
   return dateValue
  }

  isDate(element){
    let dateValue
    dateValue = element

    if(element){
      if(element['_nanoseconds'] || element['_seconds']){
        const NS_TO_MS_MULTIPLIER = 1/1000000
        const SEC_TO_MS_MULTIPLIER = 1000
        const timestampInMilliseconds = element['_seconds'] * SEC_TO_MS_MULTIPLIER + element['_nanoseconds'] * NS_TO_MS_MULTIPLIER
        const date = new Date(timestampInMilliseconds)
        element= date
        // dateValue = date.toDateString()
        dateValue = date
      }

      if(element['nanoseconds'] || element['seconds']){
        const NS_TO_MS_MULTIPLIER = 1/1000000
        const SEC_TO_MS_MULTIPLIER = 1000
        const timestampInMilliseconds = element['seconds'] * SEC_TO_MS_MULTIPLIER + element['nanoseconds'] * NS_TO_MS_MULTIPLIER
        const date = new Date(timestampInMilliseconds)
        element= date
        dateValue = date
        // dateValue = date.toDateString()
      }

      if( typeof element === 'string'){
        const date = new Date(element)
        dateValue = date
        // dateValue = date.toDateString()
      }
      if(!element['_nanoseconds'] && !element['_seconds'] && !element['nanoseconds'] && !element['seconds']){
        // if( typeof element === 'date'){
          const date = new Date(element)
        dateValue = date
        // dateValue = date.toDateString()
        // }
      }
      if( typeof element === 'object'){
        const date = new Date(element)
        dateValue = date
        // dateValue = date.toDateString()
      }

      try{
        let date = new Date(dateValue)
        dateValue = date
        // dateValue = date.toLocaleDateString('de-DE',{year: 'numeric', month: '2-digit', day:'2-digit'})
      }catch(e){}
    }
   return dateValue
  }

  isTime(element){
    let dateValue
    dateValue = element
    if(element){
      if(element['_nanoseconds'] || element['_seconds']){
        const NS_TO_MS_MULTIPLIER = 1/1000000
        const SEC_TO_MS_MULTIPLIER = 1000
        const timestampInMilliseconds = element['_seconds'] * SEC_TO_MS_MULTIPLIER + element['_nanoseconds'] * NS_TO_MS_MULTIPLIER
        const date = new Date(timestampInMilliseconds)
        element= date
        dateValue = date
        // dateValue = date.toLocaleTimeString('de-DE', { hour: "2-digit", minute: "2-digit" })
      }
      if(element['nanoseconds'] || element['seconds']){
        const NS_TO_MS_MULTIPLIER = 1/1000000
        const SEC_TO_MS_MULTIPLIER = 1000
        const timestampInMilliseconds = element['_seconds'] * SEC_TO_MS_MULTIPLIER + element['_nanoseconds'] * NS_TO_MS_MULTIPLIER
        const date = new Date(timestampInMilliseconds)
        element= date
        dateValue = date
        // dateValue = date.toLocaleTimeString('de-DE', { hour: "2-digit", minute: "2-digit" })
      }

      if( typeof element === 'object'){
        const date = new Date(element)
        dateValue = date
        // dateValue = date.toLocaleTimeString('de-DE', { hour: "2-digit", minute: "2-digit" })
      }

      if( typeof element === 'string'){
        const date = new Date(element)
        dateValue = date
        // dateValue = date.toLocaleTimeString('de-DE', { hour: "2-digit", minute: "2-digit" })
      }
    }
   return dateValue
  }

  isMedia(element, field){
    let elementMedia

    if(element[field.key]){
      elementMedia = element[field.key].split(' ')
    }

    return elementMedia
  }

  checkTypeOfArray(element, field){
    let type = false
    if(element[field.key]){
      let otype = typeof element[field.key]
      if(otype=='object'){
        type = Array.isArray(element[field.key])
      }
    }
    return type
  }

  clearURLqueryParams(){
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {  },
      queryParamsHandling:'merge'
    });

    this.reportFilterService.setQueryParams({})
  }

  extractNameFromUrl(url: string): string {
    const pattern = /([^/]+)\.pdf$/;
    const match = url.match(pattern);
    return match ? match[1] : '';
  }

  updateFilters(newFiltersTemplate:any){
    const data = {filters: newFiltersTemplate, id: this.idToShow}

    try{
      const a = this.reportService.updateReportAndReload(data)
      a.then( rsult => {
        this.clearURLqueryParams()
        this.reportService.setReportNewFilters(data)
        this.commentService.progressSpin.emit(false)
      })

    }catch(error){
    this.commentService.progressSpin.emit(false)
    console.log(error)
    }
  }

  openFilterSettingsDialog(){
    let dialogRef = this.dialog.open(ReportFilterSettingsDialogComponent, {
      data: this.reportTemplate,
      panelClass: 'custom-dialog-container',
        position: { right: '0'},
        enterAnimationDuration: '200ms',
        exitAnimationDuration: '200ms'
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        if(result[1]){
          this.updateFilters(result[0])
        }
      }
    });
  }

  loadMoreResults(){
    // when theres a limit on reportTemplate, call to load more results
    if(this.reportTemplate.contentTypeId && this.reportTemplate.resultFields && this.reportTemplate.resultFields.length!=0){

      let data = deepCopy( this.reportTemplate)
      if(data.fixedFilters && data.fixedFilters.length!=0)
        data['fixedFilters']= data.fixedFilters

      try{
        const list = this.reportService.reports_loadMoreReportResults(this.settingService.contextId$, data, this.reportLoadFromNextId)
      }catch(error){
        console.log(error)
        const message = this.translate.instant("SnackBarConstants.REPORT_LOAD_FAILED")
        this.commentService.addSnackBar.emit(message)
      }
    }else{
      //console.log('(-----)')
      const message = this.translate.instant("SnackBarConstants.MANDATORY_FIELDS_EMPTY")
      this.commentService.addSnackBar.emit(message)
    }
  }

  get hasActiveFilters(): boolean {
    return this.agGridReportsApi
        ? Object.keys(this.agGridReportsApi.getFilterModel() || {}).length > 0
        : false;
  }

  get hasStoredPreferences(): boolean {
      return !!this.localStorageService.get(this.gridStateKey);
  }

  onQuickFilterChanged(value: string): void {
    this.agGridReportsApi?.setGridOption('quickFilterText', value);
  }

}